var map = {
	"./noble01/头像框@2x.png": "d578",
	"./noble02/头像框@2x.png": "00ef",
	"./noble03/头像框@2x.png": "205c",
	"./noble04/头像框@2x.png": "06c7",
	"./noble05/头像框@2x.png": "3585"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "63bf";